const AISkeleton = () => {
  return (
    <div className="ai-skeleton">
      <div className="skeleton-line w-50"></div>
      <div className="skeleton-line w-100"></div>
      <div className="skeleton-line w-90"></div>
      <div className="skeleton-line w-80"></div>
    </div>
  );
};

export default AISkeleton;